export const systemMessage = {
  taxreturnAmendedApproval: 'taxreturn-amended-approval'
};
